import React, { useCallback } from 'react'
import {
  ViewBody,
} from 'components/Sidebar'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import BoardBlockers from 'routes/Board/Blockers'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  ControlLabel,
} from 'react-bootstrap'
import { FieldHookConfig, useField } from 'formik'
import { ListItem } from 'components/List'
import styled from 'styled-components'
import SelectBlocker from './SelectBlocker'
import { ModalBoardContext, ModalCardContext } from 'components/Modal'
import { useCardContext } from 'dataProviders/Card'
import { useBoardContext } from 'dataProviders/Board'
import BlockerListItem from 'components/BlockerListItem'

const None = styled.span`
  opacity: 0.5;
`

type Props = LeftSidebarProps & FieldHookConfig<number> & {
  disabled?: boolean;
}

const BlockerTypeField: React.FC<Props> = ({
  leftSidebar,
  disabled,
  ...props
}) => {
  const boardContext = useBoardContext()
  const cardContext = useCardContext()

  const [field, meta, helpers] = useField(props)

  const showSelectBlocker = useCallback((setValue) => {
    leftSidebar.push(() => (
      <ModalBoardContext boardId={boardContext.id}>
        <ModalCardContext cardId={cardContext.id}>
          <SelectBlocker
            onSelect={blockerId => {
              setValue(blockerId)

              leftSidebar.pop()
            }}
          /> 
        </ModalCardContext>
      </ModalBoardContext>
    ))
  }, [leftSidebar])

  return (
    <FormGroup
      validationState={meta.error ? 'error' : null}
    >
      <ViewBody>
        <ControlLabel><FormattedMessage id='BLOCKERS_CARD_BLOCK_BLOCKER' /></ControlLabel>
      </ViewBody>
      {meta.value ? (
        <BoardBlockers>
          {blockers => {
            const blocker = blockers.find(blocker => blocker.id === meta.value)

            return (
              <BlockerListItem
                name={blocker?.name}
                description={blocker?.description}
                onClick={!disabled ? () => showSelectBlocker(helpers.setValue) : undefined}
              />
            )
          }}
        </BoardBlockers>
      ) : (
        <ListItem
          onClick={!disabled ? () => showSelectBlocker(helpers.setValue) : undefined}
        >
          <None><FormattedMessage id='BLOCKERS_CARD_BLOCK_BLOCKER_SELECT_NONE' /></None>
        </ListItem>    
      )}
    </FormGroup>
  )
}

export default withLeftSidebar(BlockerTypeField)
